<!--
  lovi
  版本说明 2020-1-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.versionDescription')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />

    <div class="scroll-wrapper">
      <img class="logo" src="~@/assets/images/public/logo_versions@2x.png" />
      <p class="text-blue">eepay V2.2</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "versions",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["platformInfo"])
  },
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  text-align: center;
  .logo {
    margin-top: 80px;
    margin-bottom: 10px;
    width: 136px;
  }
}
</style>
